/* mo-dvt.js: DreamCloud vs Tempur-Pedic chooser and layer-stack stage (sections/mo-dvt.liquid), Mattress Overstock, 2026-10-15.
   Sibling of mo-dvn.js (DreamCloud vs Nectar).
   - Each card has two pickers (DreamCloud: tier and build; Tempur-Pedic: model and feel) and the size switch serves
     both. A change swaps the card, the summary line, the rows, the layer lists and the drawing. Prices come from the
     live variants in the section's JSON (server render for the default size). Floor badges come from the shared
     tryability snippet, rendered per bed into <template>s by the section; a swap clones the right one.
   - The drawing redraws the server geometry (snippets/mo-dvt-svg.liquid): 14 units per inch, one floor line.
   - Press: a pointer press (or the button) pushes both beds at the same spot. Each band compresses with its own
     response: memory foam, TEMPUR layers and quilted tops sink and recover slowly (first-order lag), support foam
     follows at once, coils are an underdamped spring so they push back fast with a small overshoot. A trace under the
     drawing plots how far each top sinks over the last 4 seconds. It shows the idea, not a measurement; the page says
     so. Frames only change attributes (no DOM inserts in a frame), so the theme's body MutationObserver (childList)
     is not woken by the animation. Sleeps when settled or off screen. */
(function () {
  'use strict';
  var root = document.querySelector('[data-dvt]');
  if (!root || root.__dvt) return;
  root.__dvt = true;

  var dataEl = root.querySelector('[data-dvt-json]');
  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var BEDS = {};
  DATA.beds.forEach(function (b) { BEDS[b.key] = b; });

  var SVGNS = 'http://www.w3.org/2000/svg';
  var K = 14, FLOOR = 272;
  var GEO = {
    w: { VW: 640, SW: 236, G: [58, 360], FS: 12, DX: 22, DY: -12 },
    n: { VW: 360, SW: 140, G: [30, 194], FS: 9.5, DX: 12, DY: -7 }
  };
  var BRANDS = ['dreamcloud', 'tempur'];
  var BRAND = { dreamcloud: 'DreamCloud', tempur: 'Tempur-Pedic' };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function pair(s, a, b) { var p = (s || '').split(':'); return { g: p[0] || a, v: p[1] || b }; }
  var S = { 1: pair(root.getAttribute('data-a'), 'premier', 'hybrid'), 2: pair(root.getAttribute('data-b'), 'adapt', 'medium'), size: root.getAttribute('data-size') || 'Queen' };

  var sumEl = root.querySelector('[data-dvt-sum]');
  var T = {
    price: root.getAttribute('data-sum-price') || 'In [size], the DreamCloud is [pa] and the Tempur-Pedic is [pb].',
    height: root.getAttribute('data-sum-height') || 'The DreamCloud is [ha] in. tall, the Tempur-Pedic [hb] in.',
    same: root.getAttribute('data-sum-same') || 'Both are [ha] in. tall.',
    none: root.getAttribute('data-none') || 'Not made in [size]',
    np: root.getAttribute('data-np') || 'not published',
    noCoils: root.getAttribute('data-diff-none') || 'No coils',
    hybrid: root.getAttribute('data-build-h') || 'Foam over coils',
    foam: root.getAttribute('data-build-f') || 'All foam'
  };

  function key(side, g, v) { return BRANDS[side - 1] + '-' + g + '-' + v; }
  function bed(side) { return BEDS[key(side, S[side].g, S[side].v)]; }
  function made(side, g, v) { return !!BEDS[key(side, g, v)]; }
  function money(c) {
    return '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function variant(b) {
    for (var i = 0; i < b.vs.length; i++) if (b.vs[i].s === S.size) return b.vs[i];
    return null;
  }
  function lines(txt) { return (txt || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean); }
  function layers(b) { return lines(b.layers).map(function (l) { return l.split('|'); }); }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function svgEl(tag, attrs, parent) {
    var e = document.createElementNS(SVGNS, tag);
    for (var k in attrs) e.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(e);
    return e;
  }
  function r1(x) { return Math.round(x * 10) / 10; }

  /* ------------------------------------------------------------ radio groups (roving tabindex, arrows) */
  // Stretch thumb (after 21st.dev 37547 Stretch Tabs): a ghost spans the old and new choice, then lands on the new one.
  // The selected button keeps its own fill (the dark-mode harness reads pressed fills from the element itself).
  function stretch(group, from, to) {
    if (reduce || !from || !to || from === to || !group.animate) return;
    var g = group.getBoundingClientRect(), a = from.getBoundingClientRect(), b = to.getBoundingClientRect();
    var ghost = document.createElement('span');
    ghost.className = 'dvt-seg__ghost';
    ghost.setAttribute('aria-hidden', 'true');
    group.appendChild(ghost);
    function box(r) { return { left: (r.left - g.left) + 'px', top: (r.top - g.top) + 'px', width: r.width + 'px', height: r.height + 'px' }; }
    var u = { left: Math.min(a.left, b.left), top: Math.min(a.top, b.top), right: Math.max(a.right, b.right), bottom: Math.max(a.bottom, b.bottom) };
    var mid = box({ left: u.left, top: u.top, width: u.right - u.left, height: u.bottom - u.top });
    var an = ghost.animate([Object.assign({ offset: 0 }, box(a)), Object.assign({ offset: 0.45, easing: 'cubic-bezier(.22,1,.36,1)' }, mid), Object.assign({ offset: 1 }, box(b))],
      { duration: 380, easing: 'cubic-bezier(.4,0,.6,1)', fill: 'forwards' });
    to.classList.add('is-landing');
    an.onfinish = an.oncancel = function () { to.classList.remove('is-landing'); if (ghost.parentNode) ghost.parentNode.removeChild(ghost); };
  }

  function check(group, btn) {
    Array.prototype.forEach.call(group.querySelectorAll('[role="radio"]'), function (b) {
      var on = b === btn;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
    });
  }
  function radios(group, onPick) {
    function btns() { return Array.prototype.slice.call(group.querySelectorAll('[role="radio"]')).filter(function (b) { return !b.disabled; }); }
    function pick(btn, focus) {
      var prev = group.querySelector('[aria-checked="true"]');
      stretch(group, prev, btn);
      check(group, btn);
      if (focus) btn.focus();
      onPick(btn);
    }
    group.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[role="radio"]');
      if (b && !b.disabled && b.getAttribute('aria-checked') !== 'true') pick(b, false);
    });
    group.addEventListener('keydown', function (e) {
      var list = btns(), i = list.indexOf(document.activeElement), j = null;
      if (i < 0) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % list.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + list.length) % list.length;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = list.length - 1;
      if (j !== null) { e.preventDefault(); pick(list[j], true); }
    });
  }

  /* ------------------------------------------------------------ cards, summary, rows, lists */
  var cards = { 1: root.querySelector('.dvt-bed[data-side="1"]'), 2: root.querySelector('.dvt-bed[data-side="2"]') };
  var tries = {};
  Array.prototype.forEach.call(root.querySelectorAll('template[data-dvt-try]'), function (t) { tries[t.getAttribute('data-dvt-try')] = t; });
  var onlineNote = (function () { var o = root.querySelector('.dvt-online'); return o ? o.textContent : ''; })();

  function syncPickers(side) {
    var el = cards[side];
    if (!el) return;
    var gs = el.querySelector('[data-pick="g"]'), vs = el.querySelector('[data-pick="v"]');
    if (gs) { var gb = gs.querySelector('[data-g="' + S[side].g + '"]'); if (gb && gb.getAttribute('aria-checked') !== 'true') check(gs, gb); }
    if (vs) {
      Array.prototype.forEach.call(vs.querySelectorAll('[data-v]'), function (b) { b.disabled = !made(side, S[side].g, b.getAttribute('data-v')); });
      var vb = vs.querySelector('[data-v="' + S[side].v + '"]');
      if (vb && vb.getAttribute('aria-checked') !== 'true') check(vs, vb);
    }
  }

  function fillTry(el, b) {
    var slot = el.querySelector('[data-dvt-tryslot]');
    if (!slot || slot.getAttribute('data-key') === b.key) return;
    slot.setAttribute('data-key', b.key);
    while (slot.firstChild) slot.removeChild(slot.firstChild);
    var t = tries[b.key];
    var frag = t ? t.content.cloneNode(true) : null;
    if (frag && frag.querySelector('[data-mo-card-tryability]')) slot.appendChild(frag);
    else if (onlineNote && b.brand === 'dreamcloud') {
      var s = document.createElement('span'); s.className = 'dvt-online'; s.textContent = onlineNote; slot.appendChild(s);
    }
  }

  function fillCard(side) {
    var el = cards[side], b = bed(side);
    if (!el || !b) return;
    el.setAttribute('data-key', b.key);
    var v = variant(b);
    var img = el.querySelector('[data-dvt-img]');
    if (img && img.getAttribute('src') !== b.photo) img.setAttribute('src', b.photo);
    ['[data-dvt-link]', '[data-dvt-link2]', '[data-dvt-plink]'].forEach(function (s) {
      var a = el.querySelector(s);
      if (a && a.getAttribute('href') !== b.url) a.setAttribute('href', b.url);
    });
    setText(el.querySelector('[data-dvt-name]'), b.name);
    var pe = el.querySelector('[data-dvt-price]'), pt = v ? money(v.p) : T.none.replace('[size]', S.size);
    if (pe && pe.textContent !== pt) {
      pe.textContent = pt;
      if (!reduce && pe.animate) pe.animate([{ transform: 'translateY(.38em)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 280, easing: 'cubic-bezier(.22,1,.36,1)' });
    }
    setText(el.querySelector('[data-dvt-psize]'), v ? S.size : '');
    var vid = el.querySelector('[data-dvt-vid]');
    if (vid && v) vid.value = String(v.id);
    var add = el.querySelector('[data-dvt-add]');
    if (add) add.disabled = !(v && v.a);
    fillTry(el, b);
    syncPickers(side);
  }

  function summary() {
    if (!sumEl) return;
    var a = bed(1), b = bed(2), va = variant(a), vb = variant(b), out = [];
    if (va && vb) out.push(T.price.replace('[size]', S.size).replace('[pa]', money(va.p)).replace('[pb]', money(vb.p)));
    else {
      if (va) out.push('In ' + S.size + ', the DreamCloud is ' + money(va.p) + '.');
      if (vb) out.push('In ' + S.size + ', the Tempur-Pedic is ' + money(vb.p) + '.');
      if (!va) out.push('The DreamCloud ' + a.name + ' is not made in ' + S.size + '.');
      if (!vb) out.push('The Tempur-Pedic ' + b.name + ' is not made in ' + S.size + '.');
    }
    out.push(a.height === b.height ? T.same.replace('[ha]', a.height) : T.height.replace('[ha]', a.height).replace('[hb]', b.height));
    setText(sumEl, out.join(' '));
  }

  var diff = root.querySelector('[data-dvt-diff]');
  var ROWS = (root.getAttribute('data-diff-rows') || '').split('|').filter(Boolean).map(function (r) { var i = r.indexOf(':'); return [r.slice(0, i), r.slice(i + 1)]; });
  function rowVal(k, b) {
    var ls = layers(b), v = variant(b), i;
    if (k === 'build') { for (i = 0; i < ls.length; i++) if (ls[i][0] === 'coils') return T.hybrid; return T.foam; }
    if (k === 'height') return b.height + ' in.';
    if (k === 'feel') return b.firm;
    if (k === 'top') { for (i = 0; i < ls.length; i++) if (ls[i][0] !== 'cover') return ls[i][2] ? ls[i][1] + ', ' + ls[i][2] : ls[i][1]; return ''; }
    if (k === 'coils') {
      for (i = 0; i < ls.length; i++) if (ls[i][0] === 'coils') return ls[i][3] ? ls[i][3] : (ls[i][2] ? ls[i][1] + ', ' + ls[i][2] : ls[i][1]);
      return T.noCoils;
    }
    if (k === 'price') return v ? money(v.p) : T.none.replace('[size]', S.size);
    return '';
  }
  function diffRows() {
    if (!diff) return;
    var body = diff.querySelector('.dvt-diff__body'), a = bed(1), b = bed(2);
    ROWS.forEach(function (r) {
      var row = body.querySelector('[data-row="' + r[0] + '"]');
      if (!row) return;
      var va = rowVal(r[0], a), vb = rowVal(r[0], b), cells = row.querySelectorAll('.dvt-diff__v');
      setText(row.querySelector('.dvt-diff__k'), r[1].replace('[size]', S.size));
      setText(cells[0], va); setText(cells[1], vb);
      row.classList.toggle('is-diff', va !== vb);
    });
  }

  // light up a kind of layer in both drawings while a row or a list item is hovered or focused
  var HL = { mf: /memory foam/i, coils: /coils/i, quilt: /euro top|quilted top/i, support: /support/i, base: /base foam/i, pcm: /cooling|pure cool/i, tempur: /TEMPUR/, relief: /advanced relief/i };
  function highlight(kind) {
    svgs.forEach(function (svg) { svg.classList.toggle('is-hl-mode', !!kind); });
    stacks.forEach(function (pr) {
      pr.forEach(function (st) {
        st.bands.forEach(function (bd, j) {
          var on = !!kind && (bd.kind === kind || (kind === 'top' && j === 0) || (bd.kind === 'np' && HL[kind] && HL[kind].test(bd.label)));
          bd.el.classList.toggle('is-hl', on);
        });
        st.topf.classList.toggle('is-hl', kind === 'top');
      });
    });
  }
  function hlBind(el, kind) {
    el.addEventListener('mouseenter', function () { highlight(kind()); });
    el.addEventListener('mouseleave', function () { highlight(null); });
    el.addEventListener('focusin', function () { highlight(kind()); });
    el.addEventListener('focusout', function () { highlight(null); });
  }
  if (diff) Array.prototype.forEach.call(diff.querySelectorAll('[data-kind]'), function (r) { hlBind(r, function () { return r.getAttribute('data-kind'); }); });

  var lists = root.querySelector('[data-dvt-layers]');
  if (lists) {
    var kindOf = function (e) { var li = e.target.closest && e.target.closest('.dvt-ll__i'); if (!li) return null; var m = li.className.match(/dvt-ll__i--(\w+)/); return m && m[1] !== 'cover' ? m[1] : null; };
    lists.addEventListener('mouseover', function (e) { highlight(kindOf(e)); });
    lists.addEventListener('mouseleave', function () { highlight(null); });
  }
  function layerLists() {
    if (!lists) return;
    [1, 2].forEach(function (side) {
      var box = lists.querySelector('.dvt-ll[data-side="' + side + '"]');
      var b = bed(side);
      if (!box || box.getAttribute('data-key') === b.key) return;
      box.setAttribute('data-key', b.key);
      setText(box.querySelector('.dvt-ll__h'), BRAND[b.brand] + ' ' + b.name + ', ' + b.height + ' in.');
      var ol = box.querySelector('.dvt-ll__list');
      while (ol.firstChild) ol.removeChild(ol.firstChild);
      layers(b).forEach(function (f) {
        var li = document.createElement('li');
        li.className = 'dvt-ll__i dvt-ll__i--' + f[0];
        var sw = document.createElement('span'); sw.className = 'dvt-ll__sw'; sw.setAttribute('aria-hidden', 'true');
        var n = document.createElement('span'); n.className = 'dvt-ll__n'; n.textContent = f[1];
        if (f[3]) { var nt = document.createElement('span'); nt.className = 'dvt-ll__note'; nt.textContent = f[3]; n.appendChild(nt); }
        var d = document.createElement('span'); d.className = 'dvt-ll__d'; d.textContent = f[2] ? f[2] : (f[0] === 'cover' ? 'cover' : T.np);
        li.appendChild(sw); li.appendChild(n); li.appendChild(d);
        ol.appendChild(li);
      });
      var src = box.querySelector('.dvt-ll__src a');
      if (src && b.src) src.setAttribute('href', b.src);
      var nt2 = box.querySelector('.dvt-ll__note2');
      if (nt2) { setText(nt2, b.lnote || ''); nt2.hidden = !b.lnote; }
    });
  }

  /* ------------------------------------------------------------ drawing */
  var svgs = Array.prototype.slice.call(root.querySelectorAll('.dvt-svg'));
  // How much each kind of layer gives per inch (illustrative): memory foam, TEMPUR layers and quilted tops are the
  // soft, slow layers; support foam is stiffer; pocket coils are springs. A bed's total give follows its maker's own
  // feel word (softer word, deeper press). The two makers do not share one scale, so depth is only the idea.
  var MOTION = {
    quilt: { m: 'slow', f: 0.5 }, mf: { m: 'slow', f: 0.5 }, tempur: { m: 'slow', f: 0.5 }, relief: { m: 'slow', f: 0.42 },
    pcm: { m: 'fast', f: 0.08 }, support: { m: 'fast', f: 0.08 }, ergo: { m: 'fast', f: 0.08 }, hybridmat: { m: 'fast', f: 0.14 },
    base: { m: 'fast', f: 0.02 }, coils: { m: 'spring', f: 0.22 }, rest: { m: 'fast', f: 0.04 }
  };
  var GIVE = { 'Soft': 36, 'Medium-Soft': 32, 'Medium': 28, 'Medium Hybrid': 28, 'Medium-Firm': 24, 'Firm': 20, 'Extra-Firm': 16 };
  var stacks = [];   // per svg, per side

  function bandsOf(b) {
    var out = [], wsum = 0;
    lines(b.bands).forEach(function (l) {
      var f = l.split('|');
      if (f[0] === 'cover') return;
      var motion = f[4] || (MOTION[f[0]] || {}).m || 'slow';
      var frac = MOTION[f[0]] ? MOTION[f[0]].f : (motion === 'spring' ? 0.2 : motion === 'slow' ? 0.3 : 0.06);
      var bd = { kind: f[0], label: f[1], pub: f[2], th: parseFloat(f[3]) * K, motion: motion, c: 0, v: 0, lw: f[5], ln: f[6], fl: f[7] || '' };
      bd.w = frac * bd.th; wsum += bd.w;
      out.push(bd);
    });
    var give = GIVE[b.firm] || 24;
    out.forEach(function (bd) { bd.max = Math.min(bd.th * 0.8, wsum ? bd.w / wsum * give : 0); });
    return out;
  }

  var TEX = { mf: 'cells', support: 'cells', base: 'cells', tempur: 'cells', hybridmat: 'cells', relief: 'dense', ergo: 'dense', quilt: 'quilt', pcm: 'wave' };
  function buildStack(svg, geo, side) {
    var b = bed(side);
    var old = svg.querySelector('.dvt-stack[data-side="' + side + '"]');
    var g = svgEl('g', { 'class': 'dvt-stack dvt-stack--' + b.brand, 'data-side': side, transform: 'translate(' + geo.G[side - 1] + ' 0)' });
    var SW = geo.SW, FS = geo.FS, LH = FS + 2, PAD = FS * 0.75, H = parseFloat(b.height) * K, top = FLOOR - H, v = svg.getAttribute('data-v');
    var st = { g: g, b: b, bands: bandsOf(b), top: top, H: H, SW: SW, geo: geo, side: side, s: 1, sv: 0 };
    var dc = b.brand === 'dreamcloud';
    st.shadow = svgEl('path', { 'class': 'dvt-shadow' }, g);
    st.sideF = svgEl('path', { 'class': 'dvt-sideface dvt-sideface--' + b.brand }, g);
    st.sideTex = svgEl('path', { 'class': 'dvt-sidetex dvt-sidetex--' + b.brand, fill: 'url(#dvt-' + (dc ? 'rib' : 'knit') + '-' + v + ')' }, g);
    st.topf = svgEl('path', { 'class': 'dvt-topface dvt-topface--' + b.brand }, g);
    st.topTex = svgEl('path', { 'class': 'dvt-toptex', fill: 'url(#dvt-' + (dc ? 'quilt' : 'swirl') + '-' + v + ')' }, g);
    var y = top;
    st.bands.forEach(function (bd) {
      bd.y0 = y; bd.y1 = y + bd.th; y = bd.y1;
      bd.el = svgEl('path', { 'class': 'dvt-band dvt-k-' + bd.kind }, g);
      if (!bd.pub) bd.hatch = svgEl('path', { 'class': 'dvt-np', fill: 'url(#dvt-hatch-' + v + ')' }, g);
      if (TEX[bd.kind]) bd.tex = svgEl('path', { 'class': 'dvt-tex', fill: 'url(#dvt-' + TEX[bd.kind] + '-' + v + ')' }, g);
      if (bd.fl.indexOf('v') >= 0) bd.vent = svgEl('path', { 'class': 'dvt-tex dvt-vent', fill: 'url(#dvt-vent-' + v + ')' }, g);
      if (bd.kind === 'coils') {
        bd.tiers = bd.fl.indexOf('d') >= 0 ? 2 : 1;
        bd.coils = [];
        var n = Math.floor(SW / 26), pitch = Math.floor(SW / n);
        for (var c = 0; c < n; c++) {
          var cx = (c + 0.5) * pitch, pk = [];
          for (var t = 0; t < bd.tiers; t++) pk.push(svgEl('rect', { 'class': 'dvt-pocket', x: r1(cx - 9.5), width: 19, rx: 6 }, g));
          bd.coils.push({ x: cx, pockets: pk, spring: svgEl('path', { 'class': 'dvt-coil' }, g) });
        }
      }
      var rows = ((v === 'n' ? bd.ln : bd.lw) || '').split('~').filter(Boolean);
      var tx = null;
      if (rows.length) {
        tx = svgEl('text', { 'class': 'dvt-blabel' + (bd.pub ? '' : ' dvt-blabel--np') + ' dvt-blabel--k-' + bd.kind, x: PAD, y: r1(bd.y0 + (bd.th - rows.length * LH) / 2 + FS - 1), 'font-size': FS }, g);
        rows.forEach(function (r, i) {
          var ts = svgEl('tspan', { x: PAD, dy: i ? LH : 0 }, tx);
          if (r.charAt(0) === '!') { ts.setAttribute('class', 'dvt-blabel__np'); ts.textContent = r.slice(1); }
          else if (/ · not published$/.test(r)) {
            ts.appendChild(document.createTextNode(r.replace(/not published$/, '')));
            var it = svgEl('tspan', { 'class': 'dvt-blabel__np' }, ts); it.textContent = T.np;
          } else ts.textContent = r;
        });
      }
      bd.text = tx;
    });
    st.outline = svgEl('path', { 'class': 'dvt-outline' }, g);
    if (!dc) st.piping = svgEl('path', { 'class': 'dvt-piping' }, g);
    st.hl = svgEl('text', { 'class': 'dvt-hlabel', x: SW / 2, y: r1(top + geo.DY - 8), 'text-anchor': 'middle', 'font-size': FS + 1 }, g);
    st.hl.textContent = b.height + ' in. tall';
    if (old) svg.replaceChild(g, old); else svg.insertBefore(g, svg.querySelector('.dvt-pucks'));
    return st;
  }

  var NPTS = 28;
  function shape(st) {
    // displacement of each boundary (top of band j) at sample xs, from the band compressions below it
    var n = st.bands.length, SW = st.SW, x0 = st.px == null ? SW / 2 : st.px;
    var xs = [], i, j, depth = 0, sig = [];
    for (i = 0; i <= NPTS; i++) xs.push(SW * i / NPTS);
    var D = [];
    for (j = 0; j <= n; j++) D.push(new Array(NPTS + 1).fill(0));
    for (j = 0; j < n; j++) { sig.push(SW * 0.13 + depth * 0.55); depth += st.bands[j].th; }
    for (j = n - 1; j >= 0; j--) {
      var c = st.bands[j].c, sg = sig[j];
      for (i = 0; i <= NPTS; i++) {
        var dx = (xs[i] - x0) / sg;
        D[j][i] = D[j + 1][i] + c * Math.exp(-dx * dx);
      }
    }
    st.xs = xs; st.D = D;
  }
  function yOf(st, j) { return j < st.bands.length ? st.bands[j].y0 : FLOOR; }
  function edge(st, j, rev, ox, oy) {
    var xs = st.xs, D = st.D, y = yOf(st, j), out = '', i;
    ox = ox || 0; oy = oy || 0;
    if (!rev) for (i = 0; i < xs.length; i++) out += (i ? ' L' : 'M') + r1(xs[i] + ox) + ' ' + r1(y + D[j][i] + oy);
    else for (i = xs.length - 1; i >= 0; i--) out += ' L' + r1(xs[i] + ox) + ' ' + r1(y + D[j][i] + oy);
    return out;
  }
  function at(st, j, x) {
    var D = st.D, y = yOf(st, j);
    var f = x / st.SW * NPTS, i = Math.max(0, Math.min(NPTS - 1, Math.floor(f))), t = f - i;
    return y + D[j][i] * (1 - t) + D[j][i + 1] * t;
  }

  // Spread: each band lifts by a gap per band below it (E 0..1). Spread is not to scale; the page says so while it shows.
  function off(st, j) { return -E * (st.geo.FS * 0.85) * (st.bands.length - 1 - j); }
  function paint(st) {
    shape(st);
    var DX = st.geo.DX, DY = st.geo.DY, SW = st.SW, o0 = off(st, 0);
    var topR = at(st, 0, SW) + o0;
    var sideD = 'M' + SW + ' ' + r1(topR) + ' L' + (SW + DX) + ' ' + r1(topR + DY) + ' L' + (SW + DX) + ' ' + (FLOOR + DY) + ' L' + SW + ' ' + FLOOR + ' Z';
    st.sideF.setAttribute('d', sideD); st.sideTex.setAttribute('d', sideD);
    var topD = edge(st, 0, false, 0, o0) + edge(st, 0, true, DX, DY + o0) + ' Z';
    st.topf.setAttribute('d', topD); st.topTex.setAttribute('d', topD);
    st.bands.forEach(function (bd, j) {
      var oj = off(st, j);
      var d = edge(st, j, false, 0, oj) + edge(st, j + 1, true, 0, oj) + ' Z';
      bd.el.setAttribute('d', d);
      if (bd.hatch) bd.hatch.setAttribute('d', d);
      if (bd.tex) bd.tex.setAttribute('d', d);
      if (bd.vent) bd.vent.setAttribute('d', d);
      if (bd.coils) bd.coils.forEach(function (c) {
        var yt = at(st, j, c.x) + 3 + oj, yb = at(st, j + 1, c.x) - 3 + oj, th = Math.max(4, yb - yt) / bd.tiers, p = '';
        var turns = 6 / bd.tiers, gap = bd.tiers > 1 ? 5 : 1;
        for (var k = 0; k < bd.tiers; k++) {
          var y0 = yt + k * th, span = Math.max(2, th - 6 - gap), stp = span / turns, ry = Math.min(2.6, stp * 0.42);
          c.pockets[k].setAttribute('y', r1(y0)); c.pockets[k].setAttribute('height', r1(Math.max(3, th - gap)));
          for (var t = 0; t < turns; t++) {
            var ty = r1(y0 + 3 + (t + 0.5) * stp);
            p += 'M' + r1(c.x - 5.5) + ' ' + ty + ' a5.5 ' + r1(ry) + ' 0 1 0 11 0 a5.5 ' + r1(ry) + ' 0 1 0 -11 0 ';
          }
        }
        c.spring.setAttribute('d', p);
      });
      if (bd.text) {
        var lx = Math.min(SW, st.geo.FS * 6);
        var m = ((at(st, j, lx) - bd.y0) + (at(st, j + 1, lx) - bd.y1)) / 2 + oj;
        bd.text.setAttribute('transform', Math.abs(m) > 0.05 ? 'translate(0 ' + r1(m) + ')' : '');
      }
    });
    st.outline.setAttribute('d', edge(st, 0, false, 0, o0) + ' L' + SW + ' ' + FLOOR + ' L0 ' + FLOOR + ' Z' +
      ' M' + (SW + DX) + ' ' + r1(topR + DY) + ' L' + (SW + DX) + ' ' + (FLOOR + DY) + ' L' + SW + ' ' + FLOOR +
      ' M0 ' + r1(at(st, 0, 0) + o0) + ' L' + DX + ' ' + r1(at(st, 0, 0) + DY + o0) + edge(st, 0, false, DX, DY + o0).replace(/^M/, ' L') + ' L' + SW + ' ' + r1(topR));
    if (st.piping) st.piping.setAttribute('d', 'M' + SW + ' ' + r1(topR + 1.5) + ' L' + (SW + DX) + ' ' + r1(topR + DY + 1.5) + ' M' + SW + ' ' + (FLOOR - 1.5) + ' L' + (SW + DX) + ' ' + (FLOOR + DY - 1.5));
    var fade = E > 0.002 ? String(Math.max(0, 1 - E * 1.2).toFixed(3)) : null;
    [st.outline, st.sideF, st.sideTex, st.piping].forEach(function (el) { if (!el) return; if (fade === null) el.removeAttribute('opacity'); else el.setAttribute('opacity', fade); });
    st.hl.setAttribute('y', r1(st.top + DY - 8 + o0));
    if (fade === null) st.hl.removeAttribute('opacity'); else st.hl.setAttribute('opacity', String(Math.max(0, 1 - E * 2).toFixed(3)));
    st.shadow.setAttribute('d', 'M-2 ' + (FLOOR - 1) + ' H' + (SW + DX + 4) + ' L' + (SW + DX + 4) + ' ' + (FLOOR + 3) + ' H-2 Z');
    var s = st.s;
    st.g.setAttribute('transform', 'translate(' + st.geo.G[st.side - 1] + ' ' + (s === 1 ? 0 : r1(FLOOR * (1 - s))) + ')' + (s === 1 ? '' : ' scale(1 ' + s.toFixed(4) + ')'));
  }

  function rebuild(morph) {
    var prev = stacks.map(function (pr) { return pr.map(function (st) { return st.H; }); });
    stacks = svgs.map(function (svg) {
      var geo = GEO[svg.getAttribute('data-v')] || GEO.w;
      return [buildStack(svg, geo, 1), buildStack(svg, geo, 2)];
    });
    stacks.forEach(function (pr, si) {
      pr.forEach(function (st, k) {
        if (morph && !reduce && prev[si] && prev[si][k] && prev[si][k] !== st.H) st.s = prev[si][k] / st.H;
        paint(st);
      });
    });
    if (morph) kick();
  }

  /* ------------------------------------------------------------ trace: top sink under the press, last 4 seconds */
  var traceEls = [root.querySelector('[data-dvt-trace="1"]'), root.querySelector('[data-dvt-trace="2"]')];
  // a dot rides the newest point of each line (after the head dot of 21st.dev 35038 Sparkline); it moves by style only
  var dots = [root.querySelector('[data-dvt-dot="1"]'), root.querySelector('[data-dvt-dot="2"]')];
  var traceBox = root.querySelector('.dvt-trace');
  if (reduce && traceBox) traceBox.hidden = true;
  var TR = [], TRW = 4, TRY0 = 10.5, TRK = 1.35, clock = 0;
  function liveIndex() {
    for (var i = 0; i < svgs.length; i++) if (svgs[i].getBoundingClientRect().width > 0) return i;
    return 0;
  }
  function sinkOf(st) { return Math.max(0, at(st, 0, st.px == null ? st.SW / 2 : st.px) - st.top); }
  function traceSample() {
    var pr = stacks[liveIndex()];
    if (!pr) return;
    TR.push([clock, sinkOf(pr[0]), sinkOf(pr[1])]);
    while (TR.length > 2 && TR[1][0] < clock - TRW) TR.shift();
  }
  function traceDraw() {
    if (!traceEls[0]) return;
    [1, 2].forEach(function (k) {
      var pts = '';
      for (var i = 0; i < TR.length; i++) {
        var x = 640 - (clock - TR[i][0]) / TRW * 640;
        if (x < -2) continue;
        pts += r1(Math.max(0, x)) + ',' + r1(TRY0 + TR[i][k] * TRK) + ' ';
      }
      traceEls[k - 1].setAttribute('points', pts.trim());
      var dot = dots[k - 1];
      if (dot && TR.length) dot.style.top = r1((TRY0 + TR[TR.length - 1][k] * TRK) / 64 * 100) + '%';
    });
  }

  /* ------------------------------------------------------------ press physics */
  var F = 0, pressing = false, raf = 0, last = 0, rel = 0.5, visible = true, E = 0, Ev = 0, Et = 0;
  var pucks = svgs.map(function (svg) {
    var g = svg.querySelector('.dvt-pucks');
    return [1, 2].map(function () {
      var p = svgEl('g', { 'class': 'dvt-puckg', opacity: 0 }, g);
      svgEl('circle', { 'class': 'dvt-puck', r: 9, cx: 0, cy: 0 }, p);
      svgEl('circle', { 'class': 'dvt-puck-ring', r: 13, cx: 0, cy: 0 }, p);
      return p;
    });
  });

  // physics in fixed substeps of at most 1/120 s, so a slow device or a throttled tab runs at true speed
  function physics(h) {
    var moving = false, target = pressing ? 1 : 0;
    if (E !== Et || Ev) {
      var ea = 110 * (Et - E) - 2 * 0.62 * 10.5 * Ev;
      Ev += ea * h; E += Ev * h;
      if (Math.abs(Et - E) < 0.001 && Math.abs(Ev) < 0.005) { E = Et; Ev = 0; } else moving = true;
    }
    F += (target - F) * Math.min(1, h / 0.08);
    stacks.forEach(function (pr) {
      pr.forEach(function (st) {
        if (st.s !== 1 || st.sv) {
          var acc = 150 * (1 - st.s) - 2 * 0.55 * 12.2 * st.sv;
          st.sv += acc * h; st.s += st.sv * h;
          if (Math.abs(1 - st.s) < 0.0015 && Math.abs(st.sv) < 0.01) { st.s = 1; st.sv = 0; } else moving = true;
        }
        st.bands.forEach(function (bd) {
          var goal = F * bd.max;
          if (bd.motion === 'spring') {
            var w = 15, z = 0.3;
            var a2 = w * w * (goal - bd.c) - 2 * z * w * bd.v;
            bd.v += a2 * h; bd.c += bd.v * h;
          } else if (bd.motion === 'slow') {
            var tau = goal > bd.c ? 0.5 : 1.35;
            bd.c += (goal - bd.c) * Math.min(1, h / tau);
          } else {
            bd.c += (goal - bd.c) * Math.min(1, h / 0.05);
          }
          if (Math.abs(goal - bd.c) > 0.05 || Math.abs(bd.v) > 0.05) moving = true;
        });
      });
    });
    return moving;
  }

  function step(dt) {
    var moving = false, n = Math.max(1, Math.ceil(dt / 0.0083)), h = dt / n;
    for (var i = 0; i < n; i++) moving = physics(h) || moving;
    clock += dt;
    stacks.forEach(function (pr) {
      pr.forEach(function (st) { st.px = rel * st.SW; paint(st); });
    });
    pucks.forEach(function (pr, si) {
      pr.forEach(function (p, k) {
        var st = stacks[si][k], gx = st.geo.G[k], x = st.px, y = at(st, 0, x) - 13;
        p.setAttribute('transform', 'translate(' + r1(gx + x) + ' ' + r1(y) + ')');
        p.setAttribute('opacity', r1(Math.min(1, F * 1.6)));
      });
    });
    traceSample(); traceDraw();
    return moving || pressing || F > 0.01;
  }

  function loop(t) {
    raf = 0;
    var dt = last ? Math.min(0.12, (t - last) / 1000) : 0.016;
    last = t;
    if (step(dt) && visible) raf = requestAnimationFrame(loop);
    else { last = 0; }
  }
  function kick() {
    if (!raf && !reduce) {
      last = 0;
      if (TR.length) TR.push([clock, TR[TR.length - 1][1], TR[TR.length - 1][2]]);
      raf = requestAnimationFrame(loop);
    }
  }

  function press(on, x) {
    if (reduce) return;
    if (x != null) rel = Math.max(0.08, Math.min(0.92, x));
    pressing = on;
    kick();
  }

  svgs.forEach(function (svg) {
    svg.addEventListener('pointerdown', function (e) {
      var pt = svg.createSVGPoint(); pt.x = e.clientX; pt.y = e.clientY;
      var m = svg.getScreenCTM(); if (!m) return;
      var p = pt.matrixTransform(m.inverse());
      var geo = GEO[svg.getAttribute('data-v')] || GEO.w;
      var k = p.x > (geo.G[0] + geo.SW + geo.G[1]) / 2 ? 1 : 0;
      var x = (p.x - geo.G[k]) / geo.SW;
      if (x < -0.05 || x > 1.05) return;
      press(true, x);
      try { svg.setPointerCapture(e.pointerId); } catch (err) {}
    });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (ev) {
      svg.addEventListener(ev, function () { if (pressing) press(false); });
    });
  });
  var pbtn = root.querySelector('[data-dvt-press]');
  var cycle = 0;
  function pressOnce(x, hold) {
    clearTimeout(cycle);
    press(true, x);
    cycle = setTimeout(function () { press(false); }, hold || 1100);
  }
  if (pbtn) {
    if (reduce) pbtn.hidden = true;
    pbtn.addEventListener('click', function () { pressOnce(0.5, 1300); });
  }

  var stage = root.querySelector('[data-dvt-stage]');
  var sbtn = root.querySelector('[data-dvt-spread]');
  function spread(on) {
    Et = on ? 1 : 0;
    if (stage) stage.classList.toggle('is-spread', !!on);
    if (sbtn) { sbtn.setAttribute('aria-pressed', on ? 'true' : 'false'); setText(sbtn, on ? (sbtn.getAttribute('data-on') || '') : (sbtn.getAttribute('data-off') || '')); }
    if (reduce) { E = Et; Ev = 0; stacks.forEach(function (pr) { pr.forEach(paint); }); }
    else kick();
  }
  if (sbtn) sbtn.addEventListener('click', function () { spread(sbtn.getAttribute('aria-pressed') !== 'true'); });

  /* first view, once: the layers spread apart, hold, settle back on the floor line, then both beds take one press.
     Then it waits for the shopper. Reduced motion skips it. */
  if (stage && 'IntersectionObserver' in window) {
    var played = false;
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        visible = e.isIntersecting;
        if (visible && !played && !reduce) {
          played = true;
          setTimeout(function () { spread(true); }, 350);
          setTimeout(function () { spread(false); }, 1700);
          setTimeout(function () { pressOnce(0.5, 1300); }, 2500);
        }
        if (visible) kick();
      });
    }, { threshold: 0.45 }).observe(stage);
  }

  /* ------------------------------------------------------------ wire up */
  function update(side) {
    [1, 2].forEach(function (s) { if (cards[s] && (side === 'all' || side === s)) cards[s].classList.add('is-swap'); });
    fillCard(1); fillCard(2);
    summary(); layerLists(); diffRows();
    F = 0; pressing = false;
    rebuild(true);
    requestAnimationFrame(function () { [1, 2].forEach(function (s) { if (cards[s]) cards[s].classList.remove('is-swap'); }); });
  }

  var sizeG = root.querySelector('.dvt-seg--size');
  if (sizeG) radios(sizeG, function (b) { S.size = b.getAttribute('data-size'); fillCard(1); fillCard(2); summary(); diffRows(); });
  [1, 2].forEach(function (side) {
    var c = cards[side];
    if (!c) return;
    var gs = c.querySelector('[data-pick="g"]'), vs = c.querySelector('[data-pick="v"]');
    if (gs) radios(gs, function (b) {
      S[side].g = b.getAttribute('data-g');
      if (!made(side, S[side].g, S[side].v)) {
        // keep the feel if this model makes it; otherwise its Medium Hybrid (every Tempur-Pedic model has one)
        var order = side === 2 ? ['hybrid', 'medium', 'soft', 'firm'] : ['hybrid', 'foam'];
        for (var i = 0; i < order.length; i++) if (made(side, S[side].g, order[i])) { S[side].v = order[i]; break; }
      }
      update(side);
    });
    if (vs) radios(vs, function (b) { S[side].v = b.getAttribute('data-v'); update(side); });
  });

  // open a disclosure of the long version when its anchor is linked
  function openHash() {
    var h = location.hash && document.getElementById(location.hash.slice(1));
    if (h && h.tagName === 'DETAILS') h.open = true;
  }
  window.addEventListener('hashchange', openHash);
  openHash();

  // read-only snapshot for qa/flows.py: per wide-drawing stack, each band's kind and current compression (units),
  // plus the trace's last sample (sink of each top, units)
  root.dvtState = function () {
    return {
      bands: stacks.length ? stacks[0].map(function (st) { return st.bands.map(function (bd) { return [bd.kind, Math.round(bd.c * 100) / 100]; }); }) : [],
      trace: TR.length ? TR[TR.length - 1].slice(1).map(function (x) { return Math.round(x * 100) / 100; }) : [],
      state: { a: S[1], b: S[2], size: S.size }
    };
  };

  rebuild();
})();
